import { Task } from '@/types/tasks';
import { createContext } from 'react';

export type Source = 'task' | 'list' | null;

interface FilingsContextType {
  filteredFilings: Task[];
  currentFilingId: string | null;
  setFilteredFilings: (tasks: Task[]) => void;
  setCurrentFilingId: (id: string | null) => void;
  getNextFiling: (currentId: string) => Task | null;
  source: Source;
  setSource: (src: Source) => void;
}

export const FilingsContext = createContext<FilingsContextType | null>(null);
